import toInteger from './to-integer'

const toBoolean = value => !!(isNaN(value) ? value : toInteger(value))

export default toBoolean
